import { useApiQuery } from '../useApiQuery';
import { operationsClient, apiGet } from '@/lib/api';
import { schedulerEndpoints } from '@/lib/api/endpoints';
import { schedulerKeys } from '@/lib/queryKeys';
import type { SchedulerBooking } from '@/types/scheduler';

/**
 * Fetches a single booking by ID from the scheduler microservice.
 */
export function useSchedulerBooking(id: string) {
  return useApiQuery<SchedulerBooking>({
    queryKey: schedulerKeys.booking(id),
    queryFn: () => apiGet<SchedulerBooking>(operationsClient, schedulerEndpoints.booking(id)),
    enabled: Boolean(id),
  });
}
